// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"8ed081a30ff44588cfcf","655":"08b1adc4aec8683398da"}[chunkId] + ".js";
};